<template>
    <modal
        :title="title"
        :id="id"
        dialog-class="modal-dialog-vertical"
    >
<!--        <template slot="modal-header">-->
<!--            <topbar class="modal-topbar"></topbar>-->
<!--        </template>-->

        <div class="row navbar-light desk32-navbar-vertical-modal">
            <div class="col-12">
                <slot></slot>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col">
                    </div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Topbar from "@/components/Topbar";
export default {
    props: ['id', 'title'],
    components: {
        Modal,
        Topbar
    },
    data() {
        return {
        }
    },
    methods: {
        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        }
    }
}
</script>

<style lang="scss">
@media only screen and (max-width: 767px) {
    .modal-header .app-main-topbar {
        display: block!important;
    }
}
</style>
